import request from '@/utils/request';

let versionsApi = {
    // 版本列表
    getVersionsList(data, err) {
        return request._postBody('/shop/version/version/pageList', data, err);
    },
    // 新增版本
    getAddVersions(data, err) {
        return request._postBody('/shop/version/version/add', data, err);
    },
    // 删除版本
    getDelVersions(data, err) {
        return request._postBody('/shop/version/version/del', data, err);
    },
}


export default versionsApi;



// WEBPACK FOOTER //
// ./src/api/setting/versions.js